import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MatSelect } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';

@Component({
  selector: 'app-sur-question-cat-search',
  templateUrl: './sur-question-cat-search.component.html',
  styleUrls: ['./sur-question-cat-search.component.css']
})
export class SurQuestionCatSearchComponent implements OnInit {
  param: any;
  personInfo: any;
  errObject: any;
  form: FormGroup;
  errors = new Array();
  eduPackageList: IEducationPackage;
  levelInfoList: ILevelInfo;

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private eduPackageService: EducationPackageService,
    private levelInfoService: LevelInfoService,
    public dialogRef: MatDialogRef<SurQuestionCatSearchComponent>,

  ) { }

  ngOnInit() {
    this.createForm();
    this.getEduPackage();
  }

  createForm() {
    this.form = this.fb.group({
      PackageId: [null],
      LevelInfoId: [null],
      Title: [null]
    });
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
     () => {
        
      }
    );
  }
  getLevelInfo(e: MatSelect) {
    this.levelInfoService.getList(e.value).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
      () => {
        
      }
    );
  }

  submit(data: any) {
    this.dialogRef.close(data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
